<template>
  <div class="filter-container" :class="{ open: visible }">
    <TextBox
      v-model="keywords"
      :label="labels('keywords')"
      @change="onSearch"
    />
    <Separator></Separator>
    <DropList
      :data="countries"
      v-model="selectedCountry"
      :label="labels('country')"
      values="id"
      labels="name"
      @change="onCountryChanged"
    />
    <DropList
      :data="regions"
      v-model="selectedRegion"
      :label="labels('region')"
      :disabled="!selectedCountry"
      @change="onRegionChanged"
    />
    <DropList
      :data="cities"
      v-model="selectedCity"
      :label="labels('city')"
      :disabled="!selectedCountry"
      @change="onSearch"
    />
    <Separator></Separator>
    <DropList
      :data="families"
      v-model="selectedFamily"
      :label="labels('family')"
      @change="onFamilyChanged"
    />
    <DropList
      :data="types"
      v-model="selectedType"
      :label="labels('type')"
      @change="onTypeChanged"
    />
    <Separator></Separator>
    <FlatButton
      :label="labels('search')"
      blue
      @click="onSearch"
      class="hide-on-desktop"
    ></FlatButton>
  </div>
</template>

<script>
import { TextBox, DropList, FlatButton } from "clariant-vue3-forms";
import Separator from "./Separator.vue";
import { getLabel } from "../services/labels.js";

export default {
  name: "filters",
  props: ["filter-options", "visible", "initial-filter"],
  components: {
    TextBox,
    DropList,
    FlatButton,
    Separator
  },
  data() {
    return {
      keywords: "",
      cities: [],
      selectedCity: "",
      regions: [],
      selectedRegion: "",
      selectedRegionLabel: "",
      countries: [],
      selectedCountry: "",
      selectedCountryLabel: "",
      families: [],
      selectedFamily: "",
      selectedFamilyLabel: "",
      types: [],
      selectedType: "",
      selectedTypeLabel: "",
      languages: [],
      selectedLanguage: "",
      selectedLanguageLabel: ""
    };
  },
  mounted() {},
  methods: {
    labels(name) {
      return getLabel(name);
    },
    onSearch() {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        let filter = {
          keywords: { id: this.keywords, label: this.keywords },
          city: { id: this.selectedCity, label: this.selectedCity },
          country: {
            id: this.selectedCountry,
            label: this.selectedCountryLabel
          },
          region: { id: this.selectedRegion, label: this.selectedRegion },
          family: { id: this.selectedFamily, label: this.selectedFamilyLabel },
          type: { id: this.selectedType, label: this.selectedTypeLabel },
          language: {
            id: this.selectedLanguage,
            label: this.selectedLanguageLabel
          }
        };
        this.$emit("change", filter);
      }, 300);
    },
    clear() {
      this.keywords = "";
      this.selectedCity = "";
      this.selectedCountry = "";
      this.selectedRegion = "";
      this.selectedFamily = "";
      this.selectedType = "";
      this.selectedLanguage = "";
      this.selectedTypeLabel = "";
      this.selectedLanguageLabel = "";
      this.selectedCountryLabel = "";
      this.selectedRegionLabel = "";
      this.selectedFamilyLabel = "";
      this.onSearch();
    },
    capitalize(text) {
      return text.replace(/\b\w/g, l => l.toUpperCase());
    },
    removeFilter(name) {
      if (!name) return;
      console.log(`Filter name: ${name}`);

      let filterName = "";
      if (name === "keywords") {
        filterName = "keywords";
      } else {
        filterName = "selected" + this.capitalize(name);
      }
      if (this[filterName]) {
        this[filterName] = "";
        this[filterName + "Label"] = "";
        this.onSearch();
      }
    },
    onCountryChanged(e) {
      if (e && e.label) {
        this.selectedCountryLabel = e.label;
        this.onSearch();
      }
    },
    onRegionChanged(e) {
       if (e && e.label) {
        this.selectedRegionLabel = e.label;
        this.onSearch();
      }
    },
    onFamilyChanged(e) {
      if (e && e.label) {
        this.selectedFamilyLabel = e.label;
        this.onSearch();
      }
    },
    onTypeChanged(e) {
      if (e && e.label) {
        this.selectedTypeLabel = e.label;
        this.onSearch();
      }
    },
    findTaxonomyLabel(array, id) {
      if (!array || !id) return "";
      const val = array.find(el => {
        return el.id === id;
      });
      if (!val) return "";
      return val.name;
    },
    setInitialFilters() {
      //this sets initial values for filters based on the page URL parameters
      //used to link directly to a country from a tile box on the clariant.com home page
      if (!this.initialFilter) return;
      let self = this;
      this.initialFilter.split("&").forEach(function(item) {
        var pair = item.split("=");
        if (pair.length == 2) {
          var key = pair[0].toLowerCase();
          if (key == "country") {
            self.selectedCountry = pair[1];
            self.selectedCountryLabel = self.findTaxonomyLabel(
              self.countries,
              pair[1]
            );
          } else if (key == "family") {
            self.selectedFamily = pair[1];
            self.selectedFamilyLabel = self.findTaxonomyLabel(
              self.families,
              pair[1]
            );
          } else if (key == "type") {
            self.selectedType = pair[1];
            self.selectedTypeLabel = self.findTaxonomyLabel(
              self.types,
              pair[1]
            );
          }
        }
      });
    }
  },
  watch: {
    filterOptions(val) {
      console.log("Filter options changed");
      this.countries = val.countries;
      this.languages = val.languages;
      this.families = val.families;
      this.types = val.types;
      this.cities = val.cities;
      this.regions = val.regions;
      this.setInitialFilters();
    }
  }
};
</script>

<style scoped>
.filter-container {
  display: flex;
  flex-direction: column;
  width: 300px;
  padding: 20px;
  min-width: 300px;
  margin-right: 30px;
  background-color: #f5f5f5;
  border-right: 1px solid #eee;
}

.hide-on-desktop {
  display: none;
}

@media all and (max-width: 800px) {
  .filter-container {
    box-sizing: border-box;
    display: none;
    margin-right: 0;
    width: 100%;
    min-width: 100%;
  }
  .filter-container.open {
    display: flex;
  }

  .hide-on-desktop {
    display: block;
  }
}
</style>
